import httpService from './httpService';
import { useGlobalStore } from '../context/useGlobalStore';

const AuthService = {
    // LOGIN
    login: async (email, password) => {
        return await httpService.post('login', { email, password });
    },

    // AUTH TOKEN handler if needed later
    getAuthToken: async () => {
        try {
            const state = useGlobalStore.getState();
            console.log({ state });
            return null;
        } catch (error) {
            console.error({ error });
        }
    },

    // Get IP
    getIP: async () => {
        return await httpService.get('get-ip'); 
    }
};

export default AuthService;
